export function Base64ToBlob(base64String, contentType = '') {
  const sliceSize = 1024
  const byteCharacters = atob(base64String)
  const byteArrays = []
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)
    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) byteNumbers[i] = slice.charCodeAt(i)
    byteArrays.push(new Uint8Array(byteNumbers))
  }
  return new Blob(byteArrays, { type: contentType })
}

export function DataUrlToBlob(dataUrl) {
  const [meta, base64] = dataUrl.split(',')
  const type = meta.match(/data:([^;]+);/)?.[1] || 'image/png'
  return Base64ToBlob(base64, type)
}
